import {createSlice} from '@reduxjs/toolkit';

const saleProductsSlice = createSlice({
  name: 'saleProducts',
  initialState: {
    isDisplaySupportedTV: false,
  },
  reducers: {
    setIsDisplaySupportedTV: (state, action) => {
      state.isDisplaySupportedTV = action.payload;
    },
    reportAnalytics: (state, action) => {},
  },
});

export const {setIsDisplaySupportedTV, reportAnalytics} = saleProductsSlice.actions;
export default saleProductsSlice.reducer;
